<ng-template #modalLaunchBuild>
	<div class="modal-header">
		<h5 class="modal-title">
			Planification de la
			<span class="fw-bold">
				semaine
				{{ selectedWeekNumber }} ({{
					dateUtils
						.getDateOfISOWeek(selectedWeekNumber, selectedYearNumber)
						.toLocaleDateString('fr-FR')
				}}
				-
				{{
					dateUtils
						.addDays(
							dateUtils.getDateOfISOWeek(
								selectedWeekNumber,
								selectedYearNumber
							),
							6
						)
						.toLocaleDateString('fr-FR')
				}})
			</span>
		</h5>

		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="bsModalLaunchBuild?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden close"></span>
		</button>
	</div>
	<div class="modal-body">
		<div class="container ms-2">
			<div class="accordion" id="accordionExample">
				<!-- Sélecteur de semaine et d'année pour planification -->
				<div class="accordion-item">
					<h2 class="accordion-header" id="headingOne">
						<button
							class="accordion-button"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne"
						>
							Changer la semaine à planifier
						</button>
					</h2>
					<div
						id="collapseOne"
						class="accordion-collapse collapse show"
						aria-labelledby="headingOne"
					>
						<div class="accordion-body">
							<div class="row">
								<div class="col-6">
									<div class="input-group">
										<span class="input-group-text" id="basic-addon1"
											>Semaine :</span
										>
										<button
											class="btn theme-green-button"
											type="button"
											(click)="increaseOrDecreaseWeekNumber('-')"
										>
											<i class="bi bi-dash-lg" aria-hidden="true"></i>
										</button>
										<input
											type="number"
											min="1"
											max="54"
											class="form-control"
											[(ngModel)]="selectedWeekNumber"
											placeholder="{{ selectedWeekNumber }}"
											(change)="increaseOrDecreaseWeekNumber()"
										/>
										<button
											class="btn theme-green-button"
											type="button"
											(click)="increaseOrDecreaseWeekNumber('+')"
										>
											<i class="bi bi-plus-lg" aria-hidden="true"></i>
										</button>
									</div>
								</div>
								<div class="col-6">
									<div class="input-group">
										<span class="input-group-text" id="selectYear"
											>Année :</span
										>
										<button
											class="btn theme-green-button"
											type="button"
											(click)="increaseOrDecreaseYear('-')"
										>
											<i class="bi bi-dash-lg" aria-hidden="true"></i>
										</button>
										<input
											type="number"
											class="form-control"
											[(ngModel)]="selectedYearNumber"
											aria-label=""
											aria-describedby="selectYear"
										/>
										<button
											class="btn theme-green-button"
											type="button"
											(click)="increaseOrDecreaseYear('+')"
										>
											<i class="bi bi-plus-lg" aria-hidden="true"></i>
										</button>
									</div>
								</div>
							</div>
							<!-- Choix des entités à affecter -->
							<div class="my-3" *ngIf="isVehicleActive">
								<label class="form-label">Planification :</label>
								<div class="form-check">
									<input
										class="form-check-input checkConstraint"
										type="checkbox"
										id="assignProfessionals"
										name="assignmentType"
										value="professionals"
										[(ngModel)]="optimParams.assignEmployees"
									/>
									<label class="form-check-label" for="assignProfessionals">
										Planifier les professionnels
									</label>
								</div>
								<div class="form-check">
									<input
										class="form-check-input checkConstraint"
										type="checkbox"
										id="assignVehicles"
										name="assignmentType"
										value="vehicles"
										[(ngModel)]="optimParams.assignVehicles"
									/>
									<label class="form-check-label" for="assignVehicles">
										Planifier les véhicules
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Sélecteur d'employés à utiliser pour planification -->
				<div
					class="accordion-item"
					*ngIf="isOptimParamsEditable && displayEmployeeSelection"
				>
					<h2 class="accordion-header" id="headingFive">
						<button
							class="accordion-button collapsed"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseFive"
							aria-expanded="false"
							aria-controls="collapseFive"
						>
							Sélectionner les employés disponibles
						</button>
					</h2>
					<div
						id="collapseFive"
						class="accordion-collapse collapse"
						aria-labelledby="headingFive"
					>
						<div class="accordion-body">
							<div class="row">
								<button
									type="button"
									class="btn theme-blue-color-button col-6 mb-2"
									aria-current="true"
									(click)="selectEmp()"
								>
									{{
										optimParams.employees.length !== employees.length
											? 'Sélectionner tous les employés'
											: 'Désélectionner les employés'
									}}
								</button>
								<div class="list-group">
									<button
										type="button"
										class="list-group-item list-group-item-action"
										aria-current="true"
										*ngFor="let emp of employees"
										(click)="selectEmp(emp)"
										[ngClass]="{
											'theme-main-color': !optimParams.employees.includes(
												emp.id
											),
											'theme-blue-color-check text-white':
												optimParams.employees.includes(emp.id)
										}"
									>
										{{ getEmployeeDisplayName(emp) }}
										<!-- <i class="ms-3 bi bi-flag" *ngIf="emp.autoAssignment"></i> -->
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Sélecteur de jours à replanifier -->
				<div class="accordion-item">
					<h2 class="accordion-header" id="headingTwo">
						<button
							class="accordion-button collapsed"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseTwo"
							aria-expanded="false"
							aria-controls="collapseTwo"
						>
							Choisir les jours à réinitialiser
						</button>
					</h2>
					<div
						id="collapseTwo"
						class="accordion-collapse collapse"
						aria-labelledby="headingTwo"
					>
						<div class="accordion-body">
							<div class="row">
								<!--<h4 class="text-center theme-main-color">
									Horizon de replanification
								</h4>-->
								<div class="row">
									<div class="d-flex justify-content-between mb-3">
										<div
											class="btn-group me-2"
											role="group"
											aria-label="Third group"
										>
											<input
												id="buttonAllWeek"
												class="btn theme-blue-color-button"
												[ngClass]="{
													'theme-main-color': !isAllWeekSelected,
													'theme-blue-color-check text-white': isAllWeekSelected
												}"
												type="button"
												(click)="selectAllWeek()"
												[value]="'Tous'"
											/>
										</div>
										<div
											*ngFor="
												let day of optimParams.replanifDays;
												let i = index
											"
										>
											<input
												id="button{{ i }}"
												class="btn theme-blue-color-button"
												[ngClass]="{
													'theme-main-color': !optimParams.replanifDays[i],
													'theme-blue-color-check text-white':
														optimParams.replanifDays[i]
												}"
												type="button"
												(click)="changeReplanifDays(i)"
												[value]="replanifDaysString[i].substring(0, 3) + '.'"
											/>
										</div>
									</div>
									<!-- Choix des entités à affecter -->
									<div class="my-3" *ngIf="isVehicleActive">
										<label class="form-label">Réinitialisation :</label>
										<div class="form-check">
											<input
												class="form-check-input checkConstraint"
												type="checkbox"
												id="resetProfessionals"
												name="resetType"
												value="professionals"
												[(ngModel)]="optimParams.resetEmployees"
												(change)="onResetEmployeesClick()"
												[disabled]="isReplanifDaysEmpty()"
											/>
											<label class="form-check-label" for="resetProfessionals">
												Réinitialiser les professionnels
											</label>
										</div>
										<div class="form-check">
											<input
												class="form-check-input checkConstraint"
												type="checkbox"
												id="resetVehicles"
												name="resetType"
												value="vehicles"
												[(ngModel)]="optimParams.resetVehicles"
												[disabled]="isReplanifDaysEmpty()"
											/>
											<label class="form-check-label" for="resetVehicles">
												Réinitialiser les véhicules
											</label>
										</div>
									</div>

									<div class="alert alert-secondary" role="alert">
										<p class="theme-main-color">
											<i class="bi bi-info-circle me-2" aria-hidden="true"></i>
											<em
												>Les {{ labelIntervention }}s des jours sélectionnés
												seront désaffectées avant de lancer la
												planification.</em
											>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Modifier les critères d'optimisation -->
				<div class="accordion-item" *ngIf="isOptimParamsEditable">
					<h2 class="accordion-header" id="headingThree">
						<button
							class="accordion-button collapsed"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseThree"
							aria-expanded="false"
							aria-controls="collapseThree"
						>
							Modifier les critères de planification
						</button>
					</h2>
					<div
						id="collapseThree"
						class="accordion-collapse collapse"
						aria-labelledby="headingThree"
					>
						<div class="accordion-body">
							<div>
								<p class="fw-bold fs-5">Critères d'optimisation</p>

								<div
									*ngFor="
										let criteria of optimParams?.optimCriteria
											| keyvalue
											| orderByNumber
									"
									[ngClass]="{
										'd-block': getCriteriaDisplay(criteria.key),
										'd-none': !getCriteriaDisplay(criteria.key)
									}"
								>
									<label class="-inline-block align-middle col-5">{{
										getCriteriaLabel(criteria.key)
									}}</label>
									<ngx-slider
										style="width: 40%; margin-left: 10%"
										[(value)]="criteria.value"
										[options]="options"
										(userChangeEnd)="
											updateCriteria(criteria.value, criteria.key)
										"
									>
									</ngx-slider>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Modifier les contraintes d'optimisation -->
				<div class="accordion-item" *ngIf="isOptimParamsEditable">
					<h2 class="accordion-header" id="headingFour">
						<button
							class="accordion-button collapsed"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseFour"
							aria-expanded="false"
							aria-controls="collapseFour"
						>
							Modifier les contraintes de planification
						</button>
					</h2>
					<div
						id="collapseFour"
						class="accordion-collapse collapse"
						aria-labelledby="headingFour"
					>
						<div class="accordion-body">
							<div class="row">
								<p class="fw-bold fs-5">Contraintes</p>
								<div
									class="form-group"
									*ngFor="
										let constraint of optimParams.optimConstraint | keyvalue
									"
									[ngClass]="{
										'col-12 d-block': getConstraintDisplay(constraint.key),
										'd-none': !getConstraintDisplay(constraint.key)
									}"
								>
									<input
										type="checkbox"
										class="form-check-input checkConstraint"
										id="{{ constraint.key }}"
										[(ngModel)]="constraint.value"
										(change)="
											updateConstraintValue(constraint.value, constraint.key)
										"
									/>
									<label
										*ngIf="getConstraintDisplay(constraint.key) === true"
										for="{{ constraint.key }}"
									>
										&nbsp;{{ getConstraintLabel(constraint.key) }}
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button me-2"
			(click)="bsModalLaunchBuild.hide()"
		>
			Annuler
		</button>
		<button
			[disabled]="isLaunchButtonDisabled()"
			type="button"
			class="btn theme-green-button"
			(click)="
				optimParams.replanifDays.includes(true)
					? openConfirmRescheduleModal()
					: buildSolution()
			"
		>
			{{ textToDisplay }}
			<div
				class="spinner-border theme-main-color"
				role="status"
				*ngIf="builderLaunched"
			>
				<span class="visually-hidden">Loading...</span>
			</div>
		</button>
	</div>
</ng-template>

<ng-template #confirmRescheduleModal>
	<div class="modal-header text-center">
		<h4>Attention : Replanification</h4>
		<button
			type="button"
			class="btn-close pull-right"
			data-bs-dismiss="modal"
			aria-label="Close"
			(click)="bsModalConfirmReschedule.hide()"
		></button>
	</div>
	<div class="modal-body">
		En démarrant la replanification, les jours sélectionnés seront réinitialisés
		puis replanifiés. <br />
		Êtes-vous sûr de vouloir continuer ?
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button me-2"
			(click)="bsModalConfirmReschedule.hide()"
		>
			Annuler
		</button>
		<button
			[disabled]="builderLaunched"
			type="button"
			class="btn theme-green-button"
			(click)="bsModalConfirmReschedule.hide(); buildSolution()"
		>
			Replanifier
			<div
				class="spinner-border theme-main-color"
				role="status"
				*ngIf="builderLaunched"
			>
				<span class="visually-hidden">Loading...</span>
			</div>
		</button>
	</div>
</ng-template>

<ng-template #buildPerformancesModal let-close="close">
	<div class="modal-header">
		<h5 class="modal-title">Rapport de planification</h5>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="bsModalBuildPerformances.hide()"
		></button>
	</div>
	<div class="modal-body">
		<p *ngFor="let perf of solutionPerformances">{{ perf }}</p>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-green-button"
			(click)="bsModalBuildPerformances.hide()"
		>
			Fermer
		</button>
	</div>
</ng-template>
